import { useState, useEffect } from "react";
import { T } from "./theme";
import { Search, Sparkles, Send, X, CheckCircle, MessageSquare } from "lucide-react";
import PageContainer from "./components/PageContainer";
import PageHeader from "./components/PageHeader";
import PageLoading from "./components/PageLoading";
import Card from "./components/Card";
import Badge from "./components/Badge";
import Button from "./components/Button";
import LoadingSpinner from "./components/LoadingSpinner";

const TIPO_COR = {
  promotor: T.green, positivo: T.green,
  detrator: T.red,   negativo: T.red,
  passivo:  T.amber, sugestao: T.amber,
};
const TIPO_LABEL = {
  promotor: "Promotor", positivo: "Promotor",
  detrator: "Detrator", negativo: "Detrator",
  passivo:  "Passivo",  sugestao: "Passivo",
};

function RespostaDrawer({ dep, onClose }) {
  const [resposta, setResposta] = useState("");
  const [loading, setLoading]   = useState(false);
  const [enviado, setEnviado]   = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch("/api/responder-depoimento", {
      method:"POST", headers:{"Content-Type":"application/json"}, credentials:"include",
      body: JSON.stringify({ depoimento: dep }),
    }).then(r=>r.json()).then(d=>{ setResposta(d.resposta||""); setLoading(false); }).catch(()=>setLoading(false));
  }, [dep]);

  const enviar = () => {
    fetch("/api/enviar-resposta", {
      method:"POST", headers:{"Content-Type":"application/json"}, credentials:"include",
      body: JSON.stringify({ depoimento: dep, resposta }),
    }).then(()=>setEnviado(true));
  };

  const inp = {
    width: "100%", minHeight: 180,
    background: T.bgBase, border: `1px solid transparent`, borderRadius: T.inputRadius,
    padding: "16px 20px", color: T.textHi, fontSize: 14, resize: "vertical",
    outline: "none", fontFamily: T.fontBody, lineHeight: 1.6, boxSizing: "border-box",
    transition: T.transitionFast
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.4)", backdropFilter: "blur(4px)", display:"flex",justifyContent:"flex-end",zIndex:200}}>
      <div style={{
        width:"min(560px,95vw)", background:T.bgCard, borderLeft:`1px solid ${T.border}`,
        padding: "32px 40px", overflowY:"auto", display:"flex", flexDirection:"column", gap: 24,
        boxShadow:"-10px 0 40px rgba(0,0,0,0.15)"
      }}>
        {/* Header */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
             <div style={{ width: 40, height: 40, borderRadius: T.inputRadius, background: T.gradientAccent, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: `0 4px 12px ${T.primaryGlow}` }}>
               <Sparkles size={20} color="#fff"/>
             </div>
             <h3 style={{margin:0,fontSize: 20,fontFamily: T.fontTitle, fontWeight: 700,letterSpacing: "-0.01em",color:T.textHi}}>Resposta Inteligente</h3>
          </div>
          <button onClick={onClose} style={{
            background:T.bgInput,border:"none",color:T.textLow,cursor:"pointer",
            width: 32, height: 32, display:"flex", alignItems: "center", justifyContent: "center", borderRadius: 10,
            transition: T.transitionFast
          }}
          onMouseEnter={e=>{e.currentTarget.style.background=T.bgBase; e.currentTarget.style.color=T.textHi}}
          onMouseLeave={e=>{e.currentTarget.style.background=T.bgInput; e.currentTarget.style.color=T.textLow}}>
            <X size={16}/>
          </button>
        </div>

        {/* Depoimento Original */}
        <div style={{
          padding:"20px 24px", background:T.bgBase, borderRadius: T.radius,
          borderLeft:`4px solid ${TIPO_COR[dep.tipo]||T.border}`, border:`1px solid ${T.border}`, borderLeftColor:TIPO_COR[dep.tipo]||T.border
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
            <Badge color={TIPO_COR[dep.tipo]} size="md">{TIPO_LABEL[dep.tipo]||dep.tipo}</Badge>
            <span style={{ fontSize: 12, color: T.textLow, fontWeight: 500, fontFamily: T.fontBody }}>Depoimento do Cliente</span>
          </div>
          <p style={{margin:0,fontSize:14,color:T.textMid,lineHeight:1.7, fontWeight: 500, fontFamily: T.fontBody}}>"{dep.texto}"</p>
        </div>

        {/* Resposta Area */}
        {loading ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, padding: "60px 0" }}>
             <LoadingSpinner size="lg" label="Analisando tom e gerando resposta humanizada..." />
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
            <div>
              <div style={{fontSize:12,fontWeight:700,color:T.textLow,marginBottom:12,textTransform:"uppercase",letterSpacing:"0.08em", fontFamily: T.fontTitle}}>Sugestão de Resposta</div>
              <textarea
                value={resposta}
                onChange={e=>setResposta(e.target.value)}
                style={inp}
                onFocus={e => { e.currentTarget.style.borderColor = T.accent; e.currentTarget.style.boxShadow = `0 0 0 3px ${T.accentDim}`; e.currentTarget.style.background = T.bgCard; }}
                onBlur={e => { e.currentTarget.style.borderColor = "transparent"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.background = T.bgBase; }}
              />
            </div>
            {enviado
              ? <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10,padding:"16px",background:`${T.green}10`,border:`1px solid ${T.green}30`,borderRadius: T.radius,color:T.green,fontSize:14, fontWeight: 600, fontFamily: T.fontBody}}>
                  <CheckCircle size={18}/> Resposta registrada e enviada na plataforma.
                </div>
              : <div style={{display:"flex",gap:12}}>
                  <Button variant="secondary" onClick={()=>navigator.clipboard.writeText(resposta)} style={{flex:1}}>
                    Copiar
                  </Button>
                  <Button variant="primary" icon={Send} onClick={enviar} style={{flex:2}}>
                    Enviar Resposta
                  </Button>
                </div>}
          </div>
        )}
      </div>
    </div>
  );
}

export default function Depoimentos() {
  const [items, setItems]     = useState([]);
  const [total, setTotal]     = useState(0);
  const [page, setPage]       = useState(1);
  const [tipo, setTipo]       = useState("todos");
  const [busca, setBusca]     = useState("");
  const [debouncedQ, setDebouncedQ] = useState("");
  const [loading, setLoading] = useState(true);
  const [drawer, setDrawer]   = useState(null);

  // Debounce search input by 400ms
  useEffect(() => {
    const t = setTimeout(() => { setDebouncedQ(busca.trim()); setPage(1); }, 400);
    return () => clearTimeout(t);
  }, [busca]);

  useEffect(() => {
    setLoading(true);
    const q = debouncedQ ? `&q=${encodeURIComponent(debouncedQ)}` : "";
    fetch(`/api/depoimentos?tipo=${tipo}&page=${page}&limit=20${q}`, { credentials:"include" })
      .then(r=>r.json()).then(d=>{ setItems(d.items||[]); setTotal(d.total||0); setLoading(false); })
      .catch(e => { console.warn("Depoimentos fetch:", e.message); setLoading(false); });
  }, [tipo, page, debouncedQ]);

  const filtrados = items;

  return (
    <PageContainer maxWidth={1200}>
      <PageHeader icon={MessageSquare} title="Central de Depoimentos" description={`${total} opiniões qualitativas registradas na rede`} />

      {/* Filters and Search */}
      <div style={{display:"flex",gap:16,marginBottom:32,flexWrap:"wrap",alignItems:"stretch"}}>
        <div style={{ display: "flex", gap: 8, background: T.bgCard, padding: 6, borderRadius: T.radius, border: `1px solid ${T.border}` }}>
            {["todos","promotor","passivo","detrator"].map(t=>(
            <button key={t} onClick={()=>{setTipo(t);setPage(1);}} style={{
                padding:"8px 24px",borderRadius: T.inputRadius,fontSize:13,cursor:"pointer",
                background:tipo===t?`${TIPO_COR[t]||T.accent}15`:"transparent",
                border:`1px solid ${tipo===t?`${TIPO_COR[t]||T.accent}30`:"transparent"}`,
                color:tipo===t?(TIPO_COR[t]||T.accent):T.textMid,
                fontWeight: tipo===t ? 700 : 500,
                fontFamily: T.fontBody,
                transition: T.transitionFast
            }}
            onMouseEnter={e=>{if(tipo!==t) e.currentTarget.style.background=T.bgBase}}
            onMouseLeave={e=>{if(tipo!==t) e.currentTarget.style.background="transparent"}}
            >
                {t==="todos"?"Todos os Tipos":t.charAt(0).toUpperCase()+t.slice(1)}
            </button>
            ))}
        </div>
        <div style={{flex:1,position:"relative",minWidth:280}}>
          <Search size={16} style={{position:"absolute",left:16,top:"50%",transform:"translateY(-50%)",color:T.textLow}}/>
          <input
            value={busca}
            onChange={e=>setBusca(e.target.value)}
            placeholder="Buscar por palavras-chave ou paciente..."
            style={{
                width:"100%", height: "100%", padding: T.inputPaddingWithIcon,
                background: T.bgInput, border:`1px solid ${T.border}`, borderRadius: T.inputRadius,
                color:T.textHi, fontSize:14, outline:"none", boxSizing:"border-box",
                transition: T.transitionFast, fontFamily: T.fontBody, fontWeight: 500
            }}
            onFocus={e => { e.currentTarget.style.borderColor = T.accent; e.currentTarget.style.boxShadow = `0 0 0 3px ${T.accentDim}`; e.currentTarget.style.background = T.bgCard; }}
            onBlur={e => { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.background = T.bgInput; }}
          />
        </div>
      </div>

      {loading ? <PageLoading label="Carregando depoimentos..." /> : (
        <div style={{display:"flex",flexDirection:"column",gap:16}}>
          {filtrados.map((d,i)=>(
            <Card key={i} style={{ position: "relative", overflow: "hidden" }}>
              {/* Subtle accent border */}
              <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 4, background: TIPO_COR[d.tipo]||T.border }} />

              <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:24, flexWrap: "wrap"}}>
                <div style={{flex:1, minWidth: 300}}>
                  <div style={{display:"flex",gap:8,marginBottom:8,alignItems:"center",flexWrap:"wrap"}}>
                    <span style={{fontSize:12,color:T.textLow,fontFamily:T.fontBody}}>{d.data_relato ? new Date(d.data_relato + "T12:00:00").toLocaleDateString("pt-BR") : ""}</span>
                    {d.area && <Badge color={T.accent} size="md">{d.area}</Badge>}
                    {d.categoria && <Badge color={T.textMid} size="md">{d.categoria}</Badge>}
                    <Badge color={TIPO_COR[d.tipo]} size="md">{TIPO_LABEL[d.tipo]||d.tipo}</Badge>
                    {d.solicitou_contato && <Badge color={T.amber} size="md">CONTATO SOLICITADO</Badge>}
                  </div>
                  {d.assunto && <div style={{fontSize:12,color:T.textMid,fontFamily:T.fontBody,marginBottom:6,fontStyle:"italic"}}>Assunto: {d.assunto}</div>}
                  <p style={{margin:"0 0 10px",fontSize:15,color:T.textHi,lineHeight:1.7, fontWeight: 500, fontFamily: T.fontBody}}>"{d.texto}"</p>
                  <div style={{display:"flex",gap:12,flexWrap:"wrap",alignItems:"center"}}>
                    {d.email && <span style={{fontSize:12,color:T.textLow,fontFamily:T.fontBody,padding:"3px 8px",background:T.bgInput,borderRadius:T.radiusXs,border:`1px solid ${T.border}`}}>{d.email}</span>}
                    {d.codigo && <span style={{fontSize:12,color:T.textLow,fontFamily:T.fontBody,padding:"3px 8px",background:T.bgInput,borderRadius:T.radiusXs,border:`1px solid ${T.border}`}}>#{d.codigo}</span>}
                    {d.prontuario && <span style={{fontSize:12,color:T.textLow,fontFamily:T.fontBody,padding:"3px 8px",background:T.bgInput,borderRadius:T.radiusXs,border:`1px solid ${T.border}`}}>Pront. {d.prontuario}</span>}
                  </div>
                </div>
                {d.tipo !== "positivo" && (
                  <Button variant="secondary" icon={Sparkles} onClick={()=>setDrawer(d)} style={{
                    flexShrink:0, background: T.accentDim, border:`1px solid ${T.accent}40`, color: T.accent
                  }}>
                    Resposta IA Inteligente
                  </Button>
                )}
              </div>
            </Card>
          ))}
          {filtrados.length === 0 && (
              <Card style={{ textAlign: "center", padding: 60 }}>
                  <div style={{ fontSize: 15, color: T.textLow, fontWeight: 500, fontFamily: T.fontBody }}>Nenhum depoimento encontrado para os filtros atuais.</div>
              </Card>
          )}
        </div>
      )}

      {!loading && total > 20 && (
        <div style={{display:"flex",justifyContent:"center",gap:12,marginTop:32}}>
          <Button variant="secondary" onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page===1}>
            ← Anterior
          </Button>

          <div style={{ display: "flex", alignItems: "center", padding: "0 10px", fontSize: 13, color: T.textMid, fontWeight: 600, fontFamily: T.fontBody }}>
              Página {page} de {Math.ceil(total/20)}
          </div>

          <Button variant="secondary" onClick={()=>setPage(p=>p+1)} disabled={page*20>=total}>
            Próxima →
          </Button>
        </div>
      )}

      {drawer && <RespostaDrawer dep={drawer} onClose={()=>setDrawer(null)}/>}
    </PageContainer>
  );
}
